import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useNotifications } from "@/context/NotificationContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell, BadgeCheck, MessageSquare, ShieldAlert, FileText } from "lucide-react";

const ICONS = {
  verified: BadgeCheck,
  moderation: ShieldAlert,
  resume_request: FileText,
  message: MessageSquare,
};

export function NotificationBell() {
  const { counts, markAllRead } = useNotifications();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const onOpenChange = async (o) => {
    setOpen(o);
    if (o) {
      try {
        const { data } = await api.get("/notifications");
        setItems(data);
      } catch (err) { console.warn("Failed to load notifications", err); }
      markAllRead();
    }
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button className="relative p-2 text-[#68706B] hover:text-[#1A1E1C]" data-testid="notif-bell">
          <Bell className="w-5 h-5" />
          {counts.notifications > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 bg-[#D96C5B] text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-badge">
              {counts.notifications > 9 ? "9+" : counts.notifications}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="rounded-none w-80 p-0 max-h-96 overflow-y-auto" data-testid="notif-panel">
        <div className="px-4 py-3 border-b border-[#E2E4E2] font-bold text-sm tracking-tight">Notifications</div>
        {items.length === 0 && <div className="p-6 text-sm text-[#68706B] text-center">No notifications yet.</div>}
        {items.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <button
              key={n.id}
              onClick={() => { setOpen(false); if (n.link) navigate(n.link); }}
              className={`w-full text-left px-4 py-3 border-b border-[#E2E4E2] hover:bg-[#F0EFEB] flex gap-3 ${!n.read ? "bg-[#F6F5F0]" : ""}`}
              data-testid={`notif-item-${n.id}`}
            >
              <Icon className="w-4 h-4 mt-0.5 shrink-0 text-[#1E3F33]" />
              <div className="min-w-0">
                <div className="text-sm font-semibold leading-tight">{n.title}</div>
                {n.body && <div className="text-xs text-[#68706B] mt-0.5 line-clamp-2">{n.body}</div>}
              </div>
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
